/// status 状态   sty样式
export function getJoinModel(item, status, sty) {
  let obj = {};
  Object.assign(obj, item)
  obj.isCheck = false
  return obj
}
export function getSendMessage(userConversationId, ConsultId, MessageType, Content, tip, accountId) {
  var obj = new Object();
  obj.userConversationId = userConversationId;
  obj.ConsultId = ConsultId;
  obj.messageType = MessageType;
  obj.sender = 2;
  obj.content = Content;
  obj.subscribeId = tip;
  obj.accessChatId = accountId;
  return obj;
}

export function getMiniSendMessage(objs, messageType, miniAppId, path, content, accountId) {

  var obj = new Object();
  obj.userConversationId = objs.userConversationId;
  obj.consultId = objs.consultId;
  obj.messageType = messageType;
  obj.sender = 2;
  obj.miniAppId = miniAppId;
  obj.path = path;
  obj.content = content;
  obj.accessChatId = accountId;
  return obj
}



// WEBPACK FOOTER //
// ./src/components/customer/talks/ViewModel.js